import angular from 'angular';

class asNotifier {
    constructor(textResources, growlNotifications) {
        this.textResources = textResources;
        this.growlNotifications = growlNotifications;

        this.runningId = 0;
        this.notifications = {};
    }

    addNotification(notification) {
        notification.$$id = this.runningId++;
        notification.timeout = notification.timeout || 8;
        this.notifications[notification.$$id] = notification;
    }

    removeNotification(notificationId) {
        this.notifications[notificationId] = undefined;
        delete this.notifications[notificationId];
    }

    clearAllNotifications() {
        for (const key in this.notifications) {
            const notificationId = this.notifications[key].$$id;

            this.removeNotification(notificationId);
            this.growlNotifications.element
                .find('[data-growl-id=' + notificationId + ']')
                .remove();
        }
    }

    error(message, timeout, showClose = true) {
        this.addNotification({
            type: 'error',
            message: message,
            showClose: showClose,
            timeout: timeout || -1
        });
    }

    errorAndTryAgain(message, timeout, showClose = true) {
        this.error(
            `${message} ${this.textResources.genericTryAgain} ${
                this.textResources.ifProblemPersists
            }`,
            timeout,
            showClose
        );
    }

    generic(message, timeout) {
        this.addNotification({
            message: message,
            timeout: timeout
        });
    }

    info(message, timeout) {
        this.addNotification({
            type: 'info',
            message: message,
            timeout: timeout
        });
    }

    success(message, timeout, showClose = true) {
        this.addNotification({
            type: 'success',
            message: message,
            timeout: timeout,
            showClose: showClose
        });
    }

    warn(message, timeout) {
        this.addNotification({
            type: 'warning',
            message: message,
            timeout: timeout
        });
    }
}

export default angular.module('asNotifier').service('asNotifier', asNotifier);



// WEBPACK FOOTER //
// ./modules/shared/asNotifier/asNotifier.service.js